import { selectPagination } from 'redux/helpers/pagination';
import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';

const getSectionEntities = ({ entities: { documentSections } }) => documentSections;

const getSectionsByFolderVariantForMember = ({ documentSection: { sectionsByFolderVariantForMember } }, folderVariantId) => selectPagination(sectionsByFolderVariantForMember, folderVariantId, 'sectionIds');

const getSectionForMember = createSelector(
  [getSectionEntities],
  sections => memoize(
    sectionId => sections?.[sectionId],
  ),
);

const getSectionsByFolderVariantForAdmin = (state, folderVariantId) => {
  const sectionEntities = state.entities.documentSections;
  const sectionsByFolderVariantForAdmin = state.documentSection.sectionsByFolderVariantForAdmin[folderVariantId];

  if (sectionEntities && sectionsByFolderVariantForAdmin) {
    return sectionsByFolderVariantForAdmin.map(id => sectionEntities[id])
      .sort((a, b) => a?.sortOrder - b?.sortOrder);
  }

  return null;
};

const getSectionForAdmin = createSelector(
  [getSectionEntities],
  sections => memoize(
    sectionId => sections?.[sectionId],
  ),
);

export default {
  getSectionsByFolderVariantForMember,
  getSectionForMember,
  getSectionsByFolderVariantForAdmin,
  getSectionForAdmin,
};
